import { render, staticRenderFns } from "./ScrollableText.vue?vue&type=template&id=166203ee&"
import script from "./ScrollableText.vue?vue&type=script&lang=js&"
export * from "./ScrollableText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports